import {ALERT__16, ALERT_WARNING__16, INFO__16, SUCCESS__16} from '@homeaway/svg-defs/';

const MESSAGE_TYPE = {
    NONE: 'none',
    HELP: 'help',
    ERROR: 'danger',
    WARN: 'warn',
    INFO: 'info',
    SUCCESS: 'success'
};

const ANIMATION_TYPE = {
    TRANSITION: 'TRANSITION',
    SHAKE: 'SHAKE'
};

const TRANSITION_STATE = {
    ENTER: 'ENTER',
    ENTERING: 'ENTERING',
    ENTERED: 'ENTERED',
    EXIT: 'EXIT',
    EXITING: 'EXITING',
    EXITED: 'EXITED'
};

const duration = 500;
const durationMultiplier = 0.45;
const SETTINGS = {
    SHAKE_DURATION: 600,
    TRANSITION_DURATION: duration,
    TRANSITION_DELAY: duration * durationMultiplier,
    TRANSITION_DURATION_WITH_DELAY: duration - (duration * durationMultiplier),
    LINE_HEIGHT: 18,
    NO_MAX_COUNT_MAX_HEIGHT: 200
};

const inlineMessageUtil = {
    isIcon(type) {
        return type !== MESSAGE_TYPE.NONE && type !== MESSAGE_TYPE.HELP;
    },

    getIconTypeToUse({type, prevType, animating}) {
        return animating && (type === MESSAGE_TYPE.HELP || type === MESSAGE_TYPE.NONE)
            ? prevType
            : type;
    },

    getIconMarkup({type, prevType, animating}) {
        const typeToUse = inlineMessageUtil.getIconTypeToUse({type, prevType, animating});

        return {
            [MESSAGE_TYPE.INFO]: INFO__16,
            [MESSAGE_TYPE.WARN]: ALERT_WARNING__16,
            [MESSAGE_TYPE.ERROR]: ALERT__16,
            [MESSAGE_TYPE.SUCCESS]: SUCCESS__16
        }[typeToUse] || '';
    },

    getAdjustedType(message, type = MESSAGE_TYPE.ERROR) {
        return message === '' || !message
            ? MESSAGE_TYPE.NONE
            : type;
    },

    computeAnimationType({type, prevType}) {
        return {
            iconToIcon: inlineMessageUtil.isIcon(prevType) && inlineMessageUtil.isIcon(type),
            iconToHelp: inlineMessageUtil.isIcon(prevType) && type === MESSAGE_TYPE.HELP,
            helpToIcon: prevType === MESSAGE_TYPE.HELP && inlineMessageUtil.isIcon(type),
            iconToNone: inlineMessageUtil.isIcon(prevType) && type === MESSAGE_TYPE.NONE,
            noneToIcon: prevType === MESSAGE_TYPE.NONE && inlineMessageUtil.isIcon(type),
            anyToNone: prevType !== MESSAGE_TYPE.NONE && type === MESSAGE_TYPE.NONE,
            noneToAny: prevType === MESSAGE_TYPE.NONE && type !== MESSAGE_TYPE.NONE,
            type: type !== prevType
                ? `${prevType}-to-${type}`
                : ''
        };
    },

    generateEnterExitStyles({mTop, mBottom, maxLineCount, noAnimation = false}) {
        const hasMaxCount = maxLineCount > 0;
        const marginTop = `${mTop}px`;
        const marginBottom = `${mBottom}px`;

        let maxHeight = `${maxLineCount * SETTINGS.LINE_HEIGHT}px`;
        let transitionAndEase = `${SETTINGS.TRANSITION_DURATION_WITH_DELAY}ms ease`;
        let transitionAndEaseWithDelay = `${SETTINGS.TRANSITION_DURATION_WITH_DELAY}ms ease ${SETTINGS.TRANSITION_DELAY}ms`;

        if (!hasMaxCount) {
            maxHeight = '';
            transitionAndEase = '0ms ease';
            transitionAndEaseWithDelay = `0ms ease ${SETTINGS.TRANSITION_DURATION_WITH_DELAY}ms`;
        }

        return {
            [TRANSITION_STATE.ENTER]: {
                maxHeight: '0',
                marginTop: '0',
                marginBottom: '0',
                transition: 'none'
            },
            [TRANSITION_STATE.ENTERING]: {
                maxHeight,
                marginTop,
                marginBottom,
                transition: noAnimation ? 'none' : `max-height ${transitionAndEase}, margin-top ${transitionAndEase}, margin-bottom ${transitionAndEase}`
            },
            [TRANSITION_STATE.ENTERED]: {
                maxHeight: '',
                marginTop,
                marginBottom,
                transition: 'none'
            },
            [TRANSITION_STATE.EXIT]: {
                maxHeight: hasMaxCount ? maxHeight : `${SETTINGS.NO_MAX_COUNT_MAX_HEIGHT}px`,
                marginTop,
                marginBottom,
                transition: 'none'
            },
            [TRANSITION_STATE.EXITING]: {
                maxHeight: '0',
                marginTop: '0',
                marginBottom: '0',
                transition: noAnimation ? 'none' : `max-height ${transitionAndEaseWithDelay}, margin-top ${transitionAndEaseWithDelay}, margin-bottom ${transitionAndEaseWithDelay}`,
            },
            [TRANSITION_STATE.EXITED]: {
                maxHeight: '0',
                marginTop: '0',
                marginBottom: '0',
                transition: 'none'
            }
        };
    }
};

export {
    MESSAGE_TYPE,
    ANIMATION_TYPE,
    TRANSITION_STATE,
    SETTINGS,
    inlineMessageUtil
};

export default inlineMessageUtil;